import { KTSVG } from '../../../../../../_metronic/helpers'
import { useListView } from '../core/ListViewProvider'

const SessionEditModalHeader = () => {
  const { setSessionIdForUpdate } = useListView()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>View Session</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-contents-modal-action='close'
        onClick={() => setSessionIdForUpdate && setSessionIdForUpdate(undefined)}
        style={{ cursor: 'pointer' }}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export { SessionEditModalHeader }
